import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import title from './util/title'

Vue.config.productionTip = false

Vue.mixin(title)

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
